export default __webpack_public_path__ + "static/media/screen4.67e50a55.png";